var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "Page" }, [
    _c(
      "div",
      { staticClass: "banner_w" },
      [
        _c("div", { staticClass: "bannerTit" }, [
          _c("div", { staticClass: "Title" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$store.getters.wTitle) + "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "s_w" },
          [
            _c("Search", {
              attrs: { type: 1 },
              on: { toSsearch: _vm.toSsearch },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("characteristiNav", { staticClass: "nav", attrs: { num: 2 } }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mainContent" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }